import { redirect } from 'react-router-dom'

const ORDERED_DEFAULT_ONBOARDING_ROUTES = [
  'start',
  'reason',
  'feedback-you-can-do-this',
  'vaping-duration',
  'vaping-frequency',
  'vaping-start-age',
  'previous-quit-attempts',
  'feedback-youre-taking-control',
  'craving-times',
  'hardest-part',
  'support-system',
  'feedback-knowledge-is-power',
  'health-improvements',
  'vape-spending',
  'device-duration',
  'quit-timeline',
  'feedback-imagine-what-you-could-do',
  'morning-routine',
  'social-vaping',
  'birth-year',
  'feedback-time-heals',
  'quitting-feelings',
  'quit-goals',
  'display-name',
  'feedback-great-to-meet-you',
]

export default async function navigateToNextOnboardingPageAction({
  request,
}: {
  request: Request
}) {
  const formData = await request.formData()

  const next = getNext(request.url)

  const currentPage = request.url.split('/').pop()?.split('?')[0]

  if (!next) return redirect('/sign-up/company')

  const nextPathname = getNextPathName({ next, url: request.url })

  if (currentPage === 'success') {
    const hash = formData.get('success') as string

    return redirect(`${nextPathname}#${hash}`)
  } else {
    return redirect(nextPathname)
  }
}

function getNext(url: string): string | undefined {
  const pathname = new URL(url).pathname
  const current = pathname.split('/').pop()

  if (!current) return

  const orderedOnboardingRoutes = getOrderedOnboardingRoutes()
  const currentIndex = orderedOnboardingRoutes.indexOf(current)
  const next = orderedOnboardingRoutes[currentIndex + 1]

  return next
}

function getNextPathName({ next, url }: { next: string; url: string }): string {
  const currentPathname = new URL(url).pathname
  const paths = currentPathname.split('/')
  const basePathname = paths.slice(0, -1).join('/')
  const nextPathname = basePathname + '/' + next
  return nextPathname
}

function getOrderedOnboardingRoutes(): string[] {
  return ORDERED_DEFAULT_ONBOARDING_ROUTES
}
